import React, { useEffect, useState } from 'react';

const DidYouMean = ({
  controller,
  onCorrectionClick = () => {},
  didYouMeanString
}) => {
  const [state, setState] = useState(controller.state);

  useEffect(() => controller.subscribe(() => setState(controller.state)), []);

  if (!state.hasQueryCorrection) {
    return null;
  }

  if (state.wasAutomaticallyCorrected) {
    return (
      <div className="search-masthead-headless__did-you-mean">
        {didYouMeanString}{' '}
        <button type="button" onClick={() => controller.applyCorrection()}>
          <span className="coveo-did-you-mean-word-correction">
            {state.wasCorrectedTo}
          </span>
        </button>
      </div>
    );
  }

  return (
    <div className="search-masthead-headless__did-you-mean">
      {didYouMeanString}{' '}
      <button type="button" onClick={() => controller.applyCorrection()}>
        <span className="search-masthead-headless__did-you-mean-word-correction">
          {state.queryCorrection.correctedQuery}
        </span>
      </button>
    </div>
  );
};

export default DidYouMean;
